/**
 * Onboarding flow error and gate copy
 *
 * German user-facing strings for sign-up gate failures and shared flow context messages.
 * Keeps copy out of layout components so screens stay readable.
 */

export type SignUpGateErrorReason = 'missing_sign_up_id' | 'patient_not_found' | 'patient_load_error';

export const onboardingFlowContextCopy = {
  title: 'Deine Physiofit-Einladung',
  description:
    'Du wurdest von deiner Physiotherapie per SMS eingeladen. Hier bereitest du deinen zertifizierten Gesundheitskurs vor. Im Anschluss installierst du die Physiofit App aus dem App Store.',
} as const;

export const signUpGateErrorCopy: Record<
  SignUpGateErrorReason,
  { noticeTitle: string; noticeBody: string; noticePreset: 'error' | 'warning' }
> = {
  missing_sign_up_id: {
    noticePreset: 'error',
    noticeTitle: 'Link ungültig',
    noticeBody: 'Öffne bitte den Link aus deiner SMS erneut. Sollte das Problem weiterhin bestehen, melde dich bei unserem Support.',
  },
  patient_not_found: {
    noticePreset: 'error',
    noticeTitle: 'Einladung nicht gefunden',
    noticeBody:
      'Diese Einladung existiert nicht mehr oder ist abgelaufen. Bitte wende dich an deine Praxis für eine neue Einladung oder melde dich bei unserem Support.',
  },
  patient_load_error: {
    noticePreset: 'error',
    noticeTitle: 'Laden fehlgeschlagen',
    noticeBody:
      'Die Einladung konnte nicht geladen werden. Tippe auf „Erneut versuchen“ oder lade die Seite neu. Sollte das Problem weiterhin bestehen, melde dich bei unserem Support.',
  },
};
